module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box-content"
  }, [_c('div', [_c('div', {
    staticClass: "back-btn"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBackPage
    }
  }, [_vm._v("< Volver")])], 1)]), _vm._v(" "), _c('div', [_c('steps-pagination', {
    attrs: {
      "activeStep": _vm.step,
      "isConfirmProvider": true
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.step == 0) ? _c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Datos generales")])])]
      },
      proxy: true
    }], null, false, 725694500)
  }, [_vm._v(" "), (
    _vm.provider &&
    _vm.provider.generalData.idCompanyDataStatus !==
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "start"
    }
  }, [(!_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('generalData')
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5rem"
    }
  }, [(_vm.step === 0) ? _c('el-form', {
    ref: "generalDataForm",
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-divider', [_vm._v("Datos de la empresa")]), _vm._v(" "), _c('alta-id', {
    attrs: {
      "idStatus": _vm.idStatus,
      "type": _vm.idType,
      "id": _vm.id,
      "disabled": true
    },
    on: {
      "validate-id": _vm.validateIDHandler
    }
  }), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.generalData,
      "locations": _vm.locations,
      "validation": _vm.nextStepFlag,
      "disabled": !_vm.editing
    }
  }), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.generalData.idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "float": "left"
    }
  }, [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.provider.generalData.observation) + "\n              ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.generalData.idCompanyDataStatus ===
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    key: _vm.editing,
    staticClass: "row text-center",
    staticStyle: {
      "marginRight": "120px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('generalData')
      }
    }
  }, [_vm._v("\n                Volver a enviar los datos\n              ")])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.generalData.idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION
  ) ? _c('div', {
    staticClass: "row text-center"
  }) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("\n              Siguiente >\n            ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.step === 1) ? _c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Datos Impositivos")])])]
      },
      proxy: true
    }], null, false, 498538162)
  }, [_vm._v(" "), (
    _vm.provider &&
    _vm.provider.taxData.idCompanyDataStatus !==
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "start"
    }
  }, [(!_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('taxData')
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.step == 1) ? _c('el-form', {
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-divider', [_vm._v("Datos Impositivos")]), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.companyTaxData,
      "validation": _vm.nextStepFlag,
      "disabled": !_vm.editing
    }
  }), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.taxData.idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "float": "left"
    }
  }, [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.provider.taxData.observation) + "\n              ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.taxData.idCompanyDataStatus ===
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    key: _vm.editing,
    staticClass: "row text-center",
    staticStyle: {
      "marginRight": "120px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('taxData')
      }
    }
  }, [_vm._v("\n                Volver a enviar los datos\n              ")])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.taxData.idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION
  ) ? _c('div', {
    staticClass: "row text-center"
  }) : _vm._e(), _vm._v(" "), _c('el-button-group', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Siguiente >")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.step === 2) ? _c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Datos Bancarios")])])]
      },
      proxy: true
    }], null, false, 894485228)
  }, [_vm._v(" "), (
    _vm.provider &&
    _vm.provider.paymentData.idCompanyDataStatus !==
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "start"
    }
  }, [(!_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('paymentData')
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.step == 2) ? _c('el-form', {
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-divider', [_vm._v("Datos Bancarios 1")]), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.paymentData1,
      "banks": _vm.banks,
      "bankAccountTypes": _vm.bankAccountTypes,
      "validation": _vm.nextStepFlag,
      "disabled": !_vm.editing
    }
  }), _vm._v(" "), _c('el-divider', [_vm._v("Datos Bancarios 2 (Opcional)")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "disabled": !_vm.editing,
      "active-text": "Activar",
      "inactive-text": "Desactivar"
    },
    on: {
      "change": function($event) {
        return _vm.clearOptionalPaymentData(_vm.optionalPaymentFlag.model)
      }
    },
    model: {
      value: (_vm.optionalPaymentFlag.model),
      callback: function($$v) {
        _vm.$set(_vm.optionalPaymentFlag, "model", $$v)
      },
      expression: "optionalPaymentFlag.model"
    }
  }), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.paymentData2,
      "banks": _vm.banks,
      "bankAccountTypes": _vm.bankAccountTypes,
      "disabled": !_vm.optionalPaymentFlag.model || !_vm.editing
    }
  }), _vm._v(" "), (_vm.companyTaxData.detractionSwitch.model) ? _c('el-divider') : _vm._e(), _vm._v(" "), (_vm.companyTaxData.detractionSwitch.model) ? _c('div', [_c('h6', [_vm._v("En caso de realizar actividades sujetas a detracción, por favor completar")]), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.paymentData3,
      "validation": _vm.nextStepFlag,
      "disabled": !_vm.editing
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.paymentData.idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "float": "left"
    }
  }, [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.provider.paymentData.observation) + "\n              ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.paymentData.idCompanyDataStatus ===
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    key: _vm.editing,
    staticClass: "row text-center",
    staticStyle: {
      "marginRight": "120px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('paymentData')
      }
    }
  }, [_vm._v("\n                Volver a enviar los datos\n              ")])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.paymentData.idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION
  ) ? _c('div', {
    staticClass: "row text-center"
  }) : _vm._e(), _vm._v(" "), _c('el-button-group', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("< Anterior")]), _vm._v(" "), (_vm.step <= 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Siguiente >")]) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.step == 3) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Usuario")])])]
      },
      proxy: true
    }], null, false, 516869071)
  }, [_vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('alta-form', {
    attrs: {
      "dataForm": _vm.userData,
      "validation": _vm.nextStepFlag
    }
  }), _vm._v(" "), (this.response) ? _c('p', {
    staticStyle: {
      "color": "#a94442"
    }
  }, [_vm._v("\n            " + _vm._s(this.response) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), (_vm.validateRuc) ? _c('el-button-group', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openModalTerminosYCondiciones
    }
  }, [_vm._v("Confirmar")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()])], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-12vh",
      "height": "auto",
      "overflow-y": "hidden"
    },
    attrs: {
      "title": "Confirmar Alta de Proveedor",
      "visible": _vm.showTerminosYCondiciones,
      "width": "80%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showTerminosYCondiciones = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "60vh",
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.configuration))]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked2),
      expression: "checked2"
    }],
    staticStyle: {
      "width": "15px",
      "margin": "0 5px 0 0",
      "padding-bottom": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoCodigoEtica",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked2) ? _vm._i(_vm.checked2, null) > -1 : (_vm.checked2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked2 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Acepto el\n            "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.codigoEtica
    }
  }, [_vm._v("Código de Ética y Conducta\n            ")]), _vm._v(".\n          ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticStyle: {
      "width": "15px",
      "margin": "0 5px 0 0"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoTerminos",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("\n            Acepto las políticas:\n            "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaAnticorrupcion
    }
  }, [_vm._v("Política Anticorrupción")]), _vm._v("\n            y\n            "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaRelacionamiento
    }
  }, [_vm._v("Política de Relacionamiento con Funcionarios Públicos.")])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit",
      "disabled": !_vm.checked2 || !_vm.checked
    },
    on: {
      "click": function($event) {
        return _vm.submitFormSolicitud()
      }
    }
  }, [_vm._v("\n        Aceptar\n        ")])])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fff43e22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/CompanyDataPeru.vue
// module id = 661
// module chunks = 1